import React from 'react';

const Footer = () => {
  return (
    <footer className="text-white py-6" style={{ backgroundColor: 'rgb(14, 65, 133)' }}>
      <div className="container mx-auto px-4">
        <div className="text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} Ministry of Education. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 